import Api from '@/common/api.helper'

export default {
  state: {
    diferentials: []
  },
  actions: {
    loadPurposes ({ commit }) {
      return Api.get('/diferentials/all').then(response => {
        commit('setDiferentials', response.data)
        return response
      })
    }
  },
  mutations: {
    setDiferentials (state, diferentials) {
      state.diferentials = diferentials
    }
  },
  getters: {
    diferentials (state) {
      return state.diferentials
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/diferential.js